export default __webpack_public_path__ + "static/media/a016-4.33550e27.png";